import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CardContent, Card } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { ListItem, List, ListItemIcon, ListItemText } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import PlanDetailsComponent from "../components/PlanDetailsComponent";
import useDataStore from "../store/dataStore";

const useStyles = makeStyles({
  root: {
    "padding-top": "40px",
    borderRadius: "15px",
    boxShadow: "0 0 10px 0 #e8e8e8",
    "& h4": {
      color: "#0a0e51",
      "font-family": "Nunito",
      "font-size": "20px",
      "text-align": "left",
      "margin-left": "20px",
      "border-radius": "45px",

      marginBottom: "10px",
      marginTop: "5px",
    },
  },

  content: {
    height: "auto",
  },

  list: {
    "margin-top": "30px",
  },
  listItem: {
    color: "#0a0e51",
  },
  heading: {
    "& h7": {
      fontFamily: "Nunito",
      fontSize: "12px",
      color: "#0a0e51",
      fontWeight: "Bold",
      marginLeft: "20px",
    },
  },
  packInfo: {
    margin: "2.5%",
    "& h5": {
      color: "#0a0e51",
      "font-family": "Nunito",
      "font-size": "16px",
      "text-align": "left",
      "margin-left": "20px",
      "border-radius": "45px",
      "background-color": "#FFE194",
      display: "inline",
      "padding-left": "10px",
      "padding-right": "10px",
    },
  },
  info: {
    margin: "2.5%",
    borderRadius: "7.5px",
    backgroundColor: "#fff3d5",
    paddingBottom: "10px",
    "& h7": {
      fontFamily: "Nunito",
      fontSize: "8px",
      color: "#0a0e51",
      fontWeight: "Bold",
      marginLeft: "20px",
    },
    "& p": {
      fontFamily: "Nunito",
      fontSize: "10px",
      color: "#0a0e51",
      marginLeft: "20px",
    },
  },
  ulStyle: {
    marginTop: '-20px',
    marginLeft: '20px', 
    listStyleType: 'none', 
  },
  liStyle: {
    position: 'relative',
    paddingLeft: '20px',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '0',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: '#D6AD60', 
    },
  },
});


export default function PackageDetailsComponent(props) {
  const classes = useStyles();
  const configData = useDataStore((state) => state.data);
  let benefitIndex = 0;
  const benefitsList = (props.selectedPackage.content || []).map((benefit) => {
    ++benefitIndex;
    return (
      <div>
        <ListItem >
          <ListItemIcon><CheckCircleIcon style={{ color: "#FFE194" }} /> </ListItemIcon>
          <ListItemText className={classes.listItem}><div dangerouslySetInnerHTML={{ __html: benefit }} /></ListItemText>
        </ListItem>
        {props.selectedPackage && Array.isArray(props.selectedPackage.subContents) &&typeof props.selectedPackage.subContentIndex === 'number' && typeof props.selectedPackage.isSubContentList === 'boolean' &&benefitIndex === props.selectedPackage.subContentIndex && props.selectedPackage.isSubContentList && (
            <ListItem>
              <ListItemText className={classes.listItem}>
                <ul className={classes.ulStyle}>
                  {props.selectedPackage.subContents.map((subContent, index) => (
                    <li key={index} className={classes.liStyle}>
                      {subContent}
                    </li>
                  ))}
                </ul>
              </ListItemText>
            </ListItem>
          )}
      </div>
    );
  });
  const defaultPlanDetailNotes =
    "Once we receive your request, it might take till 48 working hours for us to activate your plan.";

  let members = getMembers(props.selectedPackage, props.subId);
  let memberText = members>1? 'Members':'Member'
  let price = getPrice(props.selectedPackage, props.subId);
  let strikePrice = props.selectedPackage.strikePrice || "";
  let premium = getPremium(props.selectedPackage, props.subId);
  let contactNumber = props.selectedPackage.contactPhoneNumber || "080 4568 6596";
  let planDetailsNote =
    props.selectedPackage.planDetailsNote || defaultPlanDetailNotes;
  let planData = {
    members: members,
    duration: props.selectedPackage.duration,
    price: price,
    premium: premium,
    showStartDate: !props.selectedPackage.hideStartDate,
    hideNote: props.selectedPackage.hideNote,
    hidePlanDetails: props.selectedPackage.hidePlanDetails,
  };

  return (
    <div>
      <Card className={classes.root}>
        <Grid item container xs={12} sm={12} md={12} spacing={0}>
          <Grid item container xs={12} sm={12} md={12}>
            {/* <CardContent className={classes.content}> */}
            <Grid item container xs={12} sm={12} md={12} spacing={2}>
              <Grid item xs={12} sm={8} md={8}>
                <CardContent className={classes.packInfo + ' card-header'}>
                  <h4>{props.selectedPackage.title}</h4>
                  <h5>
                    {" "}
                    {props.selectedPackage.duration} 
                  </h5>
                  <br></br>
                  <h5>
                    {members} {memberText}
                  </h5>


                </CardContent>

              </Grid>
              {!configData.hidePrice && <Grid item xs={12} sm={4} md={4}>
                <CardContent className="amount">
                  <p>Payable Amount</p>
                  <h4>
                    ₹ {strikePrice && <del>{strikePrice}</del>} {price}
                    {props.selectedPackage.priceWithGST && (
                    <span> <i style={{ fontSize: '10px' }}>*inclusive of GST</i></span>)}
                  </h4>
                </CardContent>
              </Grid>}
              {configData.customTextBeforeBenefits && (<h4 style={{ marginTop: "20px", color: '#630A04' }}> {configData.customTextBeforeBenefits} </h4>)}
            </Grid>
            
            <List className={classes.list}>{benefitsList}</List>
            {!planData.hidePlanDetails && (
              <>
              <Grid
              item
              container
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              <h8>
                <strong>Plan Details</strong>
              </h8>
            </Grid>
            <PlanDetailsComponent planData={planData} />
            </>
            )}
            {!planData.hideNote && (
                <CardContent className={classes.info}>
                  <h9>Please Note: </h9>
                  <h9>{planDetailsNote}</h9>
                </CardContent>
              )}
          </Grid>
        </Grid>
      </Card>
      {/*<div className="footer">*/}
      {/*  <h3>Thank you for choosing MediBuddy</h3>*/}
      {/*</div>*/}

    </div>
  );
}
function getMembers(selectedPackage, id) {
  if (!selectedPackage.complexStructure) return selectedPackage.members;
  else {
    var found = selectedPackage.structure.filter(function (item) {
      return item.subId + "" === id;
    });
    return found[0].members;
  }
}
function getPrice(selectedPackage, id) {
  if (!selectedPackage.complexStructure) return selectedPackage.price;
  else {
    var found = selectedPackage.structure.filter(function (item) {
      return item.subId + "" === id;
    });
    return found[0].price;
  }
}
function getPremium(selectedPackage, id) {
  if (!selectedPackage.complexStructure) return selectedPackage.premiumAmount;
  else {
    var found = selectedPackage.structure.filter(function (item) {
      return item.subId + "" === id;
    });
    return found[0].premiumAmount;
  }
}
